<template>
  <transition name="slide-x-transition">
      <v-flex xs12 lg6 offset-lg3>
        <v-card>
          <l-list :userName="$route.params.id" :subHeader="subHeader_1" :items="states"></l-list>
        </v-card>
      </v-flex>
  </transition>
</template>

<script>
import lList from "@/components/list";
import {mapState} from 'vuex'

export default {
  name: "settings",
  components: {
    lList
  },
  computed: {
      ...mapState("user", ["currentUser"])
  },
  data() {
    return {
      subHeader_1: "Peronality",
      states: [
        {
          title: "Account",
          color: { color: "#fff" },
          subtitle: "Change name, email and password",
          icon: "mdi-account",
          name: "account",
          actionIcon: "mdi-arrow-right"
        },
        {
          title: "FAQ",
          color: { color: "#fff" },
          subtitle: "Current questions about us",
          icon: "mdi-frequently-asked-questions",
          name: "faq",
          actionIcon: "mdi-arrow-right"
        },
        {
          title: "Informations",
          color: { color: "#fff" },
          subtitle: "About, Impressum, AGB, data protection ",
          icon: "mdi-information",
          name: "informations",
          actionIcon: "mdi-arrow-right"
        },
        {
          title: "Contact",
          color: { color: "#fff" },
          subtitle: "You have any questions then email us",
          icon: "mdi-account-box",
          name: "contact",
          actionIcon: "mdi-arrow-right"
        },
        {
          title: "Feedback",
          color: { color: "#fff" },
          subtitle: "Your opinion count",
          icon: "mdi-message-alert",
          name: "feedback",
          actionIcon: "mdi-arrow-right"
        },
        {
          title: "Share",
          color: { color: "#fff" },
          subtitle: "Link us and tell about us",
          icon: "mdi-share-variant",
          name: "share",
          actionIcon: "mdi-arrow-right"
        }
      ],
    };
  },
};
</script>